import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import Group_no_row, { GroupNumberCard } from './group_row.jsx';
import Pagination from '@/components/ui/pagination';
import Reset_group_Pop from './Reset_Group_pop.jsx';
import RestrictReleaseGroupDialog from './RestrictReleaseGroupDialog.jsx';
import { userService } from "../../../_services";
import Asign_Edit_Group from './AssignEditGroupDialog.jsx';
import GrandparentConfirm from './GrandparentConfirmDialog.jsx';
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2, X } from 'lucide-react';
import { debounce } from 'lodash';

function Groupno_Page() {
    const [shortname, setShortname] = useState('');
    const [fullName, setFullName] = useState('');
    const [pageOfItems, setPageOfItems] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [filteredText, setFilteredText] = useState('All');
    const [selectedTab, setSelectedTab] = useState('Assigned');
    const [isSearching, setIsSearching] = useState(false);
    const [resetTitle, setResetTitle] = useState('Reset Group Number');
    const [isPrimaryGroup, setIsPrimaryGroup] = useState('false');
    const [showResetGroupPopup, setShowResetGroupPopup] = useState(false);
    const [addEditTitle, setAddEditTitle] = useState('');
    const [showAddEditGroupPopup, setShowAddEditGroupPopup] = useState(false);
    const [poptype, setPoptype] = useState('');
    const [groupUserId, setGroupUserId] = useState('');
    const [groupNo, setGroupNo] = useState('');
    const [username, setUsername] = useState('');
    const [groupLoader, setGroupLoader] = useState(false);
    const [groupData, setGroupData] = useState([]);
    const [grouptemp, setGrouptemp] = useState([]);
    const [showRestrictReleasePopup, setShowRestrictReleasePopup] = useState(false);
    const [restrictReleaseAction, setRestrictReleaseAction] = useState('');
    const [restrictReleaseGroupNo, setRestrictReleaseGroupNo] = useState('');
    const [restrictReleaseLoading, setRestrictReleaseLoading] = useState(false);

    const matchesSearch = useCallback((item, searchTerm) => {
        if (!searchTerm) return true;
        const lower = searchTerm.toLowerCase();
        return (
            (item.groupNumber || '').toLowerCase().includes(lower) ||
            (item.fullName || '').toLowerCase().includes(lower) ||
            (item.p_FullName || '').toLowerCase().includes(lower)
        );
    }, []);

    const debouncedSearchRef = useRef(
        debounce((searchTerm, templ) => {
            if (!searchTerm || searchTerm.trim() === '') {
                setGroupData(templ);
                setFilteredText('All');
                setIsSearching(false);
                return;
            }
            const filtered = templ.filter(item => {
                if (!item.groupNumber) return false;
                const lower = searchTerm.toLowerCase();
                return (
                    (item.groupNumber || '').toLowerCase().includes(lower) ||
                    (item.fullName || '').toLowerCase().includes(lower) ||
                    (item.p_FullName || '').toLowerCase().includes(lower)
                );
            });
            setGroupData(filtered);
            setFilteredText('All');
            setIsSearching(false);
        }, 300)
    );

    useEffect(() => {
        return () => debouncedSearchRef.current.cancel();
    }, []);

    const fetchGroupList = useCallback((UserId, UserName) => {
        setGroupLoader(true);
        try {
            userService.GroupList(UserId, UserName)
                .then(apidata => {
                    setGroupData(apidata);
                    setGrouptemp(apidata);
                    setGroupLoader(false);
                })
                .catch(error => {
                    console.error('Error in GroupList API:', error);
                    setGroupLoader(false);
                });
        } catch (error) {
            console.error('Error fetching group list:', error);
            setGroupLoader(false);
        }
    }, []);

    useEffect(() => {
        const usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
        setShortname(usernamedata.split(':')[0]);
        setFullName(usernamedata.split(':')[1]);
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        fetchGroupList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
    }, [fetchGroupList]);

    const handleSearchChange = (e) => {
        const val = e.target.value;
        setSearchInput(val);
        setIsSearching(true);
        debouncedSearchRef.current(val, grouptemp);
    };

    const clearSearch = () => {
        setSearchInput('');
        setGroupData(grouptemp);
        setFilteredText('All');
        setIsSearching(false);
        debouncedSearchRef.current.cancel();
    };

    const handletab = (tabname) => {
        if (!grouptemp || !Array.isArray(grouptemp)) return;
        debouncedSearchRef.current.cancel();
        const filtered = grouptemp.filter(item => item.groupStatus && item.groupStatus.match(tabname));
        setGroupData(filtered);
        setFilteredText(tabname);
        setSelectedTab(tabname);
        setSearchInput('');
        setPageOfItems([]);
        setIsSearching(false);
    };

    const toggle_reset_group_pop = (e, shouldRefresh = false) => {
        e.stopPropagation();
        const target = e.currentTarget || e.target;
        if (!target) {
            setShowResetGroupPopup(prev => !prev);
            if (shouldRefresh) {
                const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
                fetchGroupList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
            }
            return;
        }
        const gn = target.getAttribute('data-groupumber') || target.getAttribute('groupumber');
        const uname = target.getAttribute('data-username') || target.getAttribute('username');
        const isPrimary = target.classList.contains('true');
        if (gn && uname) {
            setShowResetGroupPopup(prev => !prev);
            setResetTitle(isPrimary ? 'Reset Primary Group Number' : 'Reset Group Number');
            setIsPrimaryGroup(isPrimary ? 'true' : 'false');
            setGroupNo(gn);
            setUsername(uname);
        } else {
            setShowResetGroupPopup(prev => !prev);
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            fetchGroupList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        }
    };

    const toggle_add_edit_group_pop = (e) => {
        e.stopPropagation();
        const target = e.currentTarget || e.target;
        const pt = target.getAttribute('data-poptype') || target.getAttribute('poptype');
        const gn = target.getAttribute('data-groupumber') || target.getAttribute('groupumber');
        const uid = target.getAttribute('data-userid') || target.getAttribute('userid');
        if (pt === 'assign') {
            setShowAddEditGroupPopup(prev => !prev);
            setAddEditTitle('Assign New Group Number ' + gn);
            setGroupNo(gn);
            setPoptype(pt);
        } else if (pt === 'edit') {
            setShowAddEditGroupPopup(prev => !prev);
            setAddEditTitle('Edit Group Number ' + gn);
            setGroupUserId(uid);
            setGroupNo(gn);
            setPoptype(pt);
        } else {
            setShowAddEditGroupPopup(prev => !prev);
        }
    };

    const success_save = () => {
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        fetchGroupList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        setShowAddEditGroupPopup(false);
    };

    const restrict_release = (event) => {
        const target = event.currentTarget || event.target;
        const targetvalue = target.getAttribute('data-tagname') || target.getAttribute('tagname');
        const groupno = target.getAttribute('data-groupumber') || target.getAttribute('groupumber');
        if (groupno && targetvalue) {
            setRestrictReleaseLoading(false);
            setRestrictReleaseAction(targetvalue);
            setRestrictReleaseGroupNo(groupno);
            setShowRestrictReleasePopup(true);
        }
    };

    const handleConfirmRestrictRelease = async () => {
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        const [userId, userName] = Usermeta_Data.split(':');

        setRestrictReleaseLoading(true);
        try {
            const apidata = await userService.UpdateGroupNumber(userId, userName, restrictReleaseGroupNo, restrictReleaseAction);
            if (apidata.length > 0 && apidata[0].code === '1') {
                setSelectedTab('Assigned');
                fetchGroupList(userId, userName);
            }
            setShowRestrictReleasePopup(false);
        } catch (error) {
            console.error('Error updating group number:', error);
        } finally {
            setRestrictReleaseLoading(false);
        }
    };

    if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id")) === true) {
        return <Navigate replace to="/signup" />;
    }
    localStorage.setItem('pagename', 'groupno');

    const dataToDisplay = pageOfItems;

    return (window.atob(localStorage.getItem('UserRole')) === "Admin" ?
        <div className="w-full max-w-full overflow-hidden space-y-6">
            <h1 className="text-3xl font-bold tracking-tight text-foreground">Group Numbers</h1>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
                <div className="relative max-w-md flex-1">
                    <Input
                        type="text"
                        placeholder="Search by group number, name, or parent..."
                        value={searchInput}
                        onChange={handleSearchChange}
                        className="pr-9"
                        disabled={groupLoader || !grouptemp.length}
                    />
                    {isSearching && (
                        <Loader2 className="absolute right-10 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-muted-foreground/70" />
                    )}
                    {searchInput && !isSearching && (
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={clearSearch}
                            className="absolute right-2 top-1/2 -translate-y-1/2 h-6 w-6"
                            aria-label="Clear search"
                            type="button"
                        >
                            <X className="h-4 w-4" />
                        </Button>
                    )}
                </div>
                <Tabs value={selectedTab}>
                    <TabsList className="bg-background">
                        <TabsTrigger
                            value="Assigned"
                            onClick={() => handletab('Assigned')}
                            disabled={groupLoader || !grouptemp.length}
                        >
                            Assigned
                        </TabsTrigger>
                        <TabsTrigger
                            value="Unassigned"
                            onClick={() => handletab('Unassigned')}
                            disabled={groupLoader || !grouptemp.length}
                        >
                            Unassigned
                        </TabsTrigger>
                        <TabsTrigger
                            value="Restricted"
                            onClick={() => handletab('Restricted')}
                            disabled={groupLoader || !grouptemp.length}
                        >
                            Restricted
                        </TabsTrigger>
                    </TabsList>
                </Tabs>
            </div>

            {/* -- Desktop table (md and above) -- */}
            <Card className="hidden md:block">
                <CardContent className="p-0">
                    {groupLoader ? (
                        <div className="flex items-center justify-center py-12">
                            <Loader2 className="h-8 w-8 animate-spin text-accent" />
                        </div>
                    ) : (
                        <div className="overflow-x-auto">
                            <Table>
                                <TableHeader>
                                    <TableRow>
                                        <TableHead>Group Number</TableHead>
                                        <TableHead>Full Name</TableHead>
                                        <TableHead>Parent Affiliate</TableHead>
                                        <TableHead>Grandparent Affiliate</TableHead>
                                        <TableHead>Commission($)</TableHead>
                                        <TableHead>Status</TableHead>
                                        <TableHead>Actions</TableHead>
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {dataToDisplay && dataToDisplay.length > 0 ? (
                                        dataToDisplay.map((grouprow, index) =>
                                            <Group_no_row
                                                key={grouprow.groupNumber ?? index}
                                                index={index}
                                                {...grouprow}
                                                toggle_reset_popup={toggle_reset_group_pop}
                                                toggle_add_edit_popup={toggle_add_edit_group_pop}
                                                restrict_release={restrict_release}
                                            />
                                        )
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} className="text-center py-8 text-muted-foreground">
                                                No records found
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                    )}
                </CardContent>
            </Card>

            {/* -- Mobile / tablet card list (below md) -- */}
            <div className="md:hidden space-y-3">
                {groupLoader ? (
                    <Card>
                        <CardContent className="flex items-center justify-center p-4 py-12 sm:p-6 sm:py-12">
                            <Loader2 className="h-8 w-8 animate-spin text-accent" />
                        </CardContent>
                    </Card>
                ) : dataToDisplay && dataToDisplay.length > 0 ? (
                    dataToDisplay.map((grouprow, index) =>
                        <GroupNumberCard
                            key={grouprow.groupNumber ?? index}
                            index={index}
                            {...grouprow}
                            toggle_reset_popup={toggle_reset_group_pop}
                            toggle_add_edit_popup={toggle_add_edit_group_pop}
                            restrict_release={restrict_release}
                        />
                    )
                ) : (
                    <Card>
                        <CardContent className="text-center p-4 py-8 sm:p-6 sm:py-8 text-muted-foreground">
                            No records found
                        </CardContent>
                    </Card>
                )}
            </div>

            {!groupLoader && (
                <Pagination items={groupData} onChangePage={setPageOfItems} searchlength={0} />
            )}

            {showResetGroupPopup && (
                <div className="resetgroup_box">
                    <Reset_group_Pop
                        toggle_reset_popup={toggle_reset_group_pop}
                        title={resetTitle}
                        group_no={groupNo}
                        grouptype={isPrimaryGroup}
                        username={username}
                    />
                </div>
            )}

            {showAddEditGroupPopup && (
                <Asign_Edit_Group
                    open={showAddEditGroupPopup}
                    onClose={() => setShowAddEditGroupPopup(false)}
                    onSave={success_save}
                    poptype={poptype}
                    userid={groupUserId}
                    groupnumber={groupNo}
                    title={addEditTitle}
                />
            )}

            <RestrictReleaseGroupDialog
                open={showRestrictReleasePopup}
                onOpenChange={setShowRestrictReleasePopup}
                action={restrictReleaseAction}
                groupNumber={restrictReleaseGroupNo}
                onConfirm={handleConfirmRestrictRelease}
                loading={restrictReleaseLoading}
            />
        </div>
        : <Navigate replace to="/page-not-found" />
    );
}

export default Groupno_Page;

